module.exports = __webpack_public_path__ + "res/MaterialIcons-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/MaterialIcons-Regular.woff
// module id = 93
// module chunks = 1